<nav class="accruals-nav" [class.hidden]="isHidden" aria-label="Accruals navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/accruals/policies"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Policies
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/accruals/employee-leave-balances"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Employees
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/accruals/leave-transactions"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Leave Transactions
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/accruals/policy-history"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Policy History
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>